import { useContext } from "react";
import { useController } from "react-hook-form";
import { FormContext } from "components/shared/Form";
import FinancialsDataGrid from "components/ui/atoms/formFields/FinancialsDataGrid";

const RHFFinancialsField = ({ name, ...props }) => {
  const {
    form: { control },
  } = useContext(FormContext);

  const { field, fieldState } = useController({
    control: control,
    name: name,
  });

  return (
    <FinancialsDataGrid
      {...field}
      isDirty={fieldState.isDirty}
      {...props}
      disabled={false}
    />
  );
};

export default RHFFinancialsField;
